
document.addEventListener("DOMContentLoaded", async () => {
    const { initFixedAnchorLink, scrollNavLink } = await import("../components/anchorlink.js");
    initFixedAnchorLink();
    scrollNavLink();

    const observerCallback = (entries, observer, header) => {
        entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('-visible');
        } else {
            entry.target.classList.remove('-visible');
        }
        });
    };

    document.querySelectorAll('.js-sticker').forEach((i) => {
        if (i) {
        const observer = new IntersectionObserver((entries) => {
            observerCallback(entries, observer, i)
        }, { threshold: 0 });
        observer.observe(i);
        }
    })

    const loadMoreEl = document.querySelectorAll('.handle-load-content');
    if (loadMoreEl) {
        const { initLoadMore } = await import('../components/load-more.js');
        initLoadMore();
    }

    // Student Communication Slider
    const studentEls = document.getElementById("js-student-slider");
    if (studentEls) {
    }
    const { renderSwiperStudents } = await import(
        "../components/swiper.js"
    );
    renderSwiperStudents(studentEls);

    // Event Communication Slider
    const eventEls = document.getElementById("slider-event");
    if (eventEls) {
        const { renderEventCommunication } = await import("../components/slider.js");
        renderEventCommunication(eventEls);
    }

    // Facility Communication Slider
    const facilityEls = document.getElementById("js-facility-slider");
    if (facilityEls) {
        const { renderFacility } = await import("../components/swiper.js");
        renderFacility(facilityEls);
    }
    // Close popup when click close button
    const { closePopupBanner } = await import('../components/popup.js');
    closePopupBanner();

    // Popup banner suppression (session + cookie based)
    const { initPopupBanner } = await import('../components/popup-banner.js');
    initPopupBanner();
});
